export hero from './modules/hero'
export pillars from './modules/pillars'
export stats from './modules/stats'
export nav from './modules/navigation'
export map from './modules/map'
export testimonials from './modules/testimonials'
export download from './modules/download'
export video from './modules/video'
export brandslider from './modules/brand-slider'
export lazyloader from './modules/lazyload'
export dashboard from './modules/dashboard'
export dealerNav from './modules/dealer-portal-navigation'
export sidecart from './modules/sidecart'
export portalSlider from './modules/portal-slider'
// export orderBuilder from './modules/create-order-builder'
// export orderBuilder2 from './modules/order-builder'
export footer from './modules/footer'
export industry from './modules/industry'
export infoSlider from './modules/info-slider'
export freight from './modules/allowable-freight-promo'
export warrantyApp from './modules/warranty-app'
export warrantyViewAll from './modules/warranty-view-all'
export shipAndBilling from './modules/shipping-and-billing'
export review from './modules/review-order'
export login from './modules/login'
export cart from './modules/checkout-cart'
export orderConfirmation from './modules/order-confirmation'
export paginationList from './modules/pagination-list'
export statementsAndBilling from './modules/statements-and-billing'
export payments from './modules/payments'
export orderHistory from './modules/order-history'
export backorders from './modules/backorders'
export invoiceHistory from './modules/invoice-history'
export training from './modules/training'
export forgot from './modules/forgot-password'
export register from './modules/register-user'
export myAccount from './modules/my-account'
// export educationEvents from './modules/education-registered-events'
export orderDetails from './modules/order-detail'
export uploadOrder from './modules/upload-order'
export modal from './modules/pd-modal'
export user from './modules/user'
export contact from './modules/contact'
export career from './modules/career'
export datePicker from './modules/date-picker'
export dailyPromo from './modules/daily-promo'
export statusBar from './modules/status-bar'
export global from './modules/global'
export fiddle from './modules/fiddle'
export registeredEvents from './modules/registered-events'
export documentList from './modules/document-list'
export rewards from './modules/pd-rewards'
export publicForm from './modules/public-form'
export products from './modules/vue/components/products/multiple-products'
export multipleproducts from './modules/vue/components/products/products'
export dashboardComponents from './modules/vue/vues/dashboard-components'
export ccrrModal from './modules/vue/components/order-builder/ccrr-modal'
export ccrr from './modules/vue/components/order-builder/ccrr'
export ccrrCard from './modules/vue/components/order-builder/ccrrcard'
export order from './modules/vue/modules/order-builder'
export obVue from './modules/vue/vues/order-builder/order-builder-search'
export sideCart from './modules/vue/modules/sidecart'
export heroSlider from './modules/hero-slider'
export testimonialSlider from './modules/testimonial-slider'
export notifications from './modules/dashboard-notification'
export headerNotifications from './modules/header-notifications'
export loginasdealer from './modules/loginAsDealer'
export partSmart from './modules/partSmart'
export PriceFileRequest from './modules/price-file-request'



// WEBPACK FOOTER //
// ./app/js/index.js